import axios from "axios"
import { apiBaseUrl, APIM_BASE_URL, oktaTokenEndpoint } from "@/constants"
import { resolveHttpTimeoutMs } from "@/utils/httpTimeout"
import { getAccessToken } from "@/utils/helper"

const apim = axios.create({
  timeout: 25000,
  headers: {
    "Content-type": "application/json",
  },
})

const httpTimeoutMs = resolveHttpTimeoutMs(
  process.env.NEXT_PUBLIC_HTTP_TIMEOUT_MS,
  process.env.HTTP_TIMEOUT_MS
)
const apiInstance = axios.create({
  baseURL: apiBaseUrl,
  timeout: httpTimeoutMs,
  headers: {
    "Content-type": "application/json",
    KohlerTarget: "AzureApp",
  },
})

export const getAPIAccessToken = async (apimHost = "") => {
  const channel = ""
  try {
    const response = await axios.post(
      `${apimHost}${oktaTokenEndpoint}?scope=guest${
        channel ? `&channel=${channel}` : ""
      }`,
      null
    )
    const { access_token } = response.data
    localStorage.setItem("okta-anonymous-access-token", access_token)
    return { access_token }
  } catch (error) {
    console.error("Error fetching access token:", error)
    return null
  }
}

apim.interceptors.request.use(
  async config => {
    config.baseURL = APIM_BASE_URL
    config.headers = config.headers || {}
    const { token: accessToken = "" } = getAccessToken() || {}
    let access_token = accessToken

    if (!accessToken) {
      const { access_token: newAccessToken } =
        (await getAPIAccessToken(APIM_BASE_URL)) || {}
      access_token = newAccessToken
    }
    config.headers.Authorization = `Bearer ${access_token}`
    return config
  },
  error => {
    return Promise.reject(error)
  }
)

apim.interceptors.response.use(
  async res => {
    return res
  },
  async error => {
    const originalConfig = error?.config || {}
    const isTokenEndpoint = originalConfig?.url?.includes(oktaTokenEndpoint)
    if (!isTokenEndpoint && error?.response?.status === 401) {
      originalConfig.headers = originalConfig.headers || {}
      return getAPIAccessToken(APIM_BASE_URL)
        .then(res => {
          const { access_token: newAccessToken } = res || {}
          originalConfig.headers.Authorization = `Bearer ${newAccessToken}`
          return apim(originalConfig)
        })
        .catch(_error => {
          return Promise.reject(_error)
        })
    }
    return Promise.reject(error)
  }
)

export { apim, apiInstance }
